import { call, put, takeEvery } from 'redux-saga/effects';
import { getLeadProfileWithNotes } from '../../requests/get_lead_profile_request';
import { getLeadProfileWithNotesRequestSuccess, getLeadProfileWithNotesRequestFailure } from '../actions/get_lead_profile.actions';
import { GET_LEADS_PROFILE_WITH_NOTES_REQUEST } from '../constants/get_lead_profile.constants';
import { message_error } from '../../../../../components/Message';

function* getLeadProfileWithNotesRequest({ _id }) {
    const { result, options, error } = yield call(getLeadProfileWithNotes, _id);
    if (result) {
        yield put(getLeadProfileWithNotesRequestSuccess(options.notes.reverse()));
    } else {
        yield put(getLeadProfileWithNotesRequestFailure(error));
        message_error('Something gone wrong!');
    }
}

export default function* getLeadProfileWithNotesSaga() {
    yield takeEvery(GET_LEADS_PROFILE_WITH_NOTES_REQUEST, getLeadProfileWithNotesRequest);
}



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/sagas/get_lead_profile_with_notes.saga.js